<script lang="ts">
import { ToolsPageController } from "../../pages/tools/tools.view";
    import SvgIcon from "../common/SvgIcon.svelte";
    import { translate } from "@lernetz/ts-lib/src/Lang";
    import { DropDown } from '@lernetz/svelte-overlays';
    import { Form } from '@lernetz/svelte-forms';
    import { Form as FormType } from '@lernetz/svelte-forms/createForm';
    import { parseQueryParams } from '@lernetz/svelte-common';
    import { Tag } from "./filter.helpers";
    import DropDownCheckboxItem from "@lernetz/svelte-overlays/dropdown/DropDownCheckboxItem.svelte";

    export let filters = [];
    export let activeTags:Tag[] = [];

    export let tools:ToolsPageController;
    export let filterEnable = false;
    let form:FormType;

    function getTag( slug: string ) {
        for (const filter of filters ) {
            const found = filter.tags.find( tag => tag.slug === slug );
            if ( found ) return found;
        }
    }

    function onChange( tags:string[] ) {
        activeTags = tags.map( tag => getTag( tag ) );
        tools.setActiveTags( activeTags );
    }

</script>

<div>
    <div class="md:items-start flex flex-col items-stretch md:flex-row-reverse">
        <div class="flex-none mb-8">
            <!-- svelte-ignore a11y-no-interactive-element-to-noninteractive-role -->
            <button
                class="flex items-center space-x-4 text-white py-3 px-6 bg-black rounded-full text-xl font-medium"
                role="presentation"
                tabindex="-1"
                aria-hidden="true"
                on:click={ e => filterEnable = !filterEnable}
                >
                <SvgIcon class="w-5 h-5" name="icon-filter"></SvgIcon>
                <div class="italic">{ translate( 'filter' )}</div>
            </button>
        </div>
        <div class="flex-1">
            <Form bind:form={form} defaultValues={ { tags:activeTags.map( t => t.slug ) } } let:form on:change={ e => onChange( e.detail.tags ) }>

            {#if filterEnable }
            <div
                class="mb-4 md:mr-12 grid gap-x-4 gap-y-6 md:gap-y-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
                {#each filters as filter }

                            <DropDown align="Bottom" let:overlay let:open>
                                <button use:overlay.trigger class="flex items-center w-full px-6 py-3 md:mb-4 text-left border-2 border-black text-l" >
                                    <div class="flex-1 overflow-x-hidden overflow-ellipsis whitespace-nowrap font-medium">{ filter.name }</div>
                                    <SvgIcon class="w-6 h-6 ext-black shrink-0" name={ open ? 'icon-arrow-up' : 'icon-arrow-down' }></SvgIcon>
                                </button>
                                <div slot="content" class="border-black border-x-2 sm:border-t-2 border-b-2 bg-white px-6 py-4" let:menu>
                                    {#each filter.tags as tag }
                                    <label class="flex columns-2 py-1">
                                        <input class="mr-2" value={tag.slug} type="checkbox" use:form.bind={'tags'} use:menu.item>
                                        <div class="label">{ tag.name }</div>
                                    </label>
                                    {/each}
                                </div>
                            </DropDown>

                {/each}
            </div>
            {/if}
            </Form>
        </div>

    </div>
    <div class="flex md:mb-8 space-x-4">
        {#each activeTags as tag }
            <button
                class="text-white mt-6 md:mt-8 py-1.5 px-3.5 bg-black rounded-full flex justify-between place-items-center"
                on:click={ e => form.setValue( 'tags', form.getValue( 'tags' ).filter( t => t !== tag.slug ) )}
            >
                {tag.name}
                <SvgIcon class="w-6 h-6" name="icon-hamburger-close"></SvgIcon>
            </button>
        {/each}
    </div>
</div>
